import React from 'react';
import { map } from 'lodash';
import { Link } from 'react-router-dom';
import { TopUpAnnatelURL } from '../../localeAssets';
import { TopUpDataAnnatelURL } from '../../localeAssets';
import ViewBalancesLink from './ViewBalancesLink';

const optionsWithIcon = ['createFreeze', 'unFreeze', 'data', 'roaming', 'voiceMail', 'parameters', 'consumption', 'internet', 'mispari'];
const topUpOptionData = ['data'];
const topUpOptionRoaming = ['roaming'];
const capitalize = (a) => { return a.charAt(0).toUpperCase() + a.slice(1) };

const OptionsItem = (title, translate, options, userProductId, hasFutureFreeze, isFrozen, currentLanguage, hasFutureMispari, hasMispariActive, canActivateMispari, balance, Data) => {
  const items = map(options, (option, key) => {
    let displayOption = translate(option)
    if (option === "mispari") {
      displayOption = ''
      if (isFrozen) {
        displayOption = translate('mispari-option-when-line-is-frozen')
      }
      else if (hasMispariActive || hasFutureMispari) {
        displayOption = translate('change-existing-mispari')
      }
      else if (canActivateMispari) {
        displayOption = translate('start-mispari')
      }

      return (
        displayOption ?
          <li key={key} className="list-action-item">
            <Link className={`btn btn-action` + (isFrozen ? ` disabled-link` : ``)} to={`/${currentLanguage}/services/line/${option}/${userProductId}/0`}>
              <span className="nav-link-text"> {displayOption} </span>
            </Link>
          </li> :
          ''
      );
    }
    if (option === 'parameters') {
      displayOption = translate('apn-filter')
    }
    if (option === "moving" || option === "fax" || option === "callForward" || option === "infiniteMobile" || option === "displayNumber") {
      return
    } else if (option === "createFreeze") {
      return (
        <li key={key} className="list-action-item">
          <Link className="btn btn-action" to={`/${currentLanguage}/services/line/freeze/${userProductId}/0`}>
            {displayOption}
          </Link>
        </li>
      );
    } else if (option === "unFreeze") {
      return (
        isFrozen || hasFutureFreeze ?
          <li key="unfrezze" className="list-action-item">
            <Link className="btn btn-action" to={`/${currentLanguage}/services/line/freeze/${userProductId}/0`}>
              {translate('see-existing-freeze')}
            </Link>
          </li> :
          ''
      );
    }
    return (
      <li key={key} className="list-action-item">
        <Link className="btn btn-action" to={`/${currentLanguage}/services/line/${option}/${userProductId}/0`}>
          {displayOption}
        </Link>
      </li>
    );
  })

  return (
    <div>
      {items[0] ?
        <ul className="list-action ">
          {map(options, (option, key) => {
            let displayOption = translate(option);
            let IconComponent = optionsWithIcon.includes(option) ? require(`../Icons/${capitalize(option)}Icon.js`).default : '';
            if (option === "mispari") {
              displayOption = ''
              if (isFrozen) {
                displayOption = translate('mispari-option-when-line-is-frozen')
              }
              else if (hasMispariActive || hasFutureMispari) {
                displayOption = translate('change-existing-mispari')
              }
              else if (canActivateMispari) {
                displayOption = translate('start-mispari')
              }
              return (
                displayOption ?
                  <li key={key} className="list-action-item">
                    <IconComponent fill={isFrozen ? 'grey' : ''} />
                    <Link className={`btn btn-action` + (isFrozen ? ` disabled-link` : ``)} to={`/${currentLanguage}/services/line/${option}/${userProductId}/0`}>
                      <span className="nav-link-text"> {displayOption} </span>
                    </Link>
                  </li> :
                  ''
              );
            }
            if (option === 'parameters') {
              displayOption = ''
              if (!Data.offer.toLowerCase().includes('cacher')) {
                displayOption = translate('apn-filter')
              }
              return (
                displayOption ?
                  <li key={key} className="list-action-item">
                    <IconComponent />
                    <Link className="btn btn-action" to={`/${currentLanguage}/services/line/${option}/${userProductId}/0`}>
                      <span className="nav-link-text">{displayOption}</span>
                    </Link>
                  </li> :
                  ''
              );
            }
            if (option === "moving" || option === "fax" || option === "callForward" || option === "infiniteMobile" || option === "displayNumber") {
              return
            }
            else if (option === "createFreeze") {
              return (
                displayOption ?
                  <li key={key} className="list-action-item">
                    <IconComponent />
                    <Link className="btn btn-action" to={`/${currentLanguage}/services/line/freeze/${userProductId}/0`}>
                      <span className="nav-link-text"> {displayOption} </span>
                    </Link>
                  </li> :
                  ''
              );
            }
            else if (option === "unFreeze") {
              return (
                isFrozen || hasFutureFreeze ?
                  <li key="unfrezze" className="list-action-item">
                    <IconComponent />
                    <Link className="btn btn-action" to={`/${currentLanguage}/services/line/freeze/${userProductId}/0`}>
                      <span className="nav-link-text">{translate('see-existing-freeze')}</span>
                    </Link>
                  </li> :
                  ''
              );
            }
            else if (topUpOptionData.includes(option)) {
              if (Data.category.toLowerCase().includes("prepaye")) {
                displayOption = translate('data-prepaid')
              }
              return (
                displayOption ?
                  <li key={option} className="list-action-item" id={option}>
                    <IconComponent />
                    <a className="btn btn-action nav-link-text" href={TopUpDataAnnatelURL(option, title, Data)}>
                      <span className="nav-link-text"> {displayOption}  </span></a>
                  </li> :
                  ''
              );
            }
            else if (topUpOptionRoaming.includes(option)) {
              return (
                displayOption ?
                  <li key={option} className="list-action-item" id={option}>
                    <IconComponent />
                    <a className="btn btn-action nav-link-text" href={TopUpAnnatelURL(option, title)}>
                      <span className="nav-link-text"> {displayOption}  </span></a>
                  </li> :
                  ''
              );
            }

            return (
              displayOption ?
                <li key={key} className="list-action-item">
                  <IconComponent />
                  <Link className="btn btn-action" to={`/${currentLanguage}/services/line/${option}/${userProductId}/0`}>
                    <span className="nav-link-text">{displayOption}</span>
                  </Link>
                </li> :
                ''
            );

          })}

          {!Data.category.toLowerCase().includes("fixe") ?
            <ViewBalancesLink balance={balance} translate={translate} currentLanguage={currentLanguage} formatedNumber={title} /> : ''
          }
        </ul> :
        <div className="no-list-action-text "><span className="">{translate('no-options-message')}</span></div>
      }
    </div>

  );
};

export default OptionsItem;



// WEBPACK FOOTER //
// ./src/components/MyServices/OptionsItem.js